export const SEARCH_PSYCHOLOGISTS_KEY_PREFIX =
  'AppointmentsReserve.SearchFacultative.Steps.Psychologist.';
